import { address } from 'helpers';
import { Fade } from 'helpers/animation';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import styled from 'styled-components';
import {
  REGISTER_ADDRESS_FINDER_NAME,
  REGISTER_ADDRESS_POST_CODE_NAME,
  REGISTER_ADDRESS_STATE_NAME,
  REGISTER_ADDRESS_STREET_NAME_NAME,
  REGISTER_ADDRESS_STREET_NO_NAME,
  REGISTER_ADDRESS_STREET_TYPE_NAME,
  REGISTER_ADDRESS_SUBURB_NAME,
  REGISTER_ADDRESS_UNITNAME_NAME,
} from '../../../../../constants';
import {
  DESKTOP_MIN_WIDTH,
  RESET_BACKDROP_STORE,
} from '../../../../../constants/common';
import useStore from '../../../../../hooks/useStore';
import { SET_SHOW_BACKDROP } from '../../../../../store/action';
import FormInputAddressPostcodeValidation from '../FormInputAddressPostcodeValidation';

const CustomAddressPostcodeDropdown = ({
  ref,
  field,
  information,
  validation,
  setInformation,
  setValidation,
  checkFormInputValidation,
}) => {
  const { dispatch } = useStore();

  const [postcodeSuggestion, setPostcodeSuggestion] = useState(null);

  const handleDropdownItemSelected = (e, postcodeObj, field) => {
    e.preventDefault();

    const { postcode, locality, state } = postcodeObj;

    document.getElementsByName(field.name)[0].value = postcode;

    let newInformation = {
      ...information,
      [field.name]: postcode,
      [REGISTER_ADDRESS_SUBURB_NAME]: locality,
      [REGISTER_ADDRESS_STATE_NAME]: state,
    };

    const currentFullAddress = address.addressCombine(
      newInformation[REGISTER_ADDRESS_UNITNAME_NAME],
      newInformation[REGISTER_ADDRESS_STREET_NO_NAME],
      newInformation[REGISTER_ADDRESS_STREET_NAME_NAME],
      newInformation[REGISTER_ADDRESS_STREET_TYPE_NAME]?.key,
      newInformation[REGISTER_ADDRESS_SUBURB_NAME],
      newInformation[REGISTER_ADDRESS_STATE_NAME],
      newInformation[REGISTER_ADDRESS_POST_CODE_NAME]
    );
    newInformation = {
      ...newInformation,
      [REGISTER_ADDRESS_FINDER_NAME]: currentFullAddress,
    };

    setInformation(newInformation);

    let newValidation = { ...validation };

    newValidation = {
      ...newValidation,
      [field.name]: '',
      [REGISTER_ADDRESS_SUBURB_NAME]: '',
      [REGISTER_ADDRESS_STATE_NAME]: '',
    };

    newValidation = checkFormInputValidation(postcode, field, newValidation);

    setValidation(newValidation);

    setPostcodeSuggestion(null);

    dispatch({
      type: SET_SHOW_BACKDROP,
      payload: RESET_BACKDROP_STORE,
    });
  };

  const renderPostcodeSuggestionDropdown = () => {
    if (isEmpty(postcodeSuggestion)) return null;
    return (
      <DropdownMenu show={true}>
        {postcodeSuggestion?.map((postcode, index) => (
          <DropdownItem
            key={postcode.fullAddress}
            eventKey={index + 1}
            onClick={(e) => handleDropdownItemSelected(e, postcode, field)}
          >
            {`${postcode.postcode} (${postcode.locality} ${postcode.state})`}
          </DropdownItem>
        ))}
      </DropdownMenu>
    );
  };

  return (
    <AddressDropdownStyled>
      <FormInputAddressPostcodeValidation
        ref={ref}
        field={field}
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
        postcodeSuggestion={postcodeSuggestion}
        setPostcodeSuggestion={setPostcodeSuggestion}
        checkFormInputValidation={checkFormInputValidation}
      />
      {renderPostcodeSuggestionDropdown()}
    </AddressDropdownStyled>
  );
};

const AddressDropdownStyled = styled.div`
  position: relative;
  width: 100%;
  ${Fade};
`;
const DropdownMenu = styled(Dropdown.Menu)`
  padding: 0;
  border: none;
  box-shadow: var(--ds-bs-4);
  max-height: 160px;
  border-radius: 0.375rem;
  width: 100%;
  overflow: auto;
  background: var(--ds-c-white);
  inset: 0px auto auto 0px !important;
  transform: translate(0px, 72px) !important;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--ds-c-grey-hover);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;
const DropdownItem = styled(Dropdown.Item)`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: var(--ds-c-grey-dark);

  display: flex;
  align-items: center;
  padding: 10px;
  text-transform: uppercase;
  min-height: 40px;
  height: fit-content;
  white-space: break-spaces;
  background: var(--ds-c-white);

  a:first-child {
    border-radius: 0.375rem 0.375rem 0 0;
  }

  &:hover {
    background: var(--ds-c-grey-light);
  }

  &:active {
    color: var(--ds-c-grey-dark);
  }

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

export default CustomAddressPostcodeDropdown;
